export const createCenterTextPlugin = (values) => {
    return {
        id: "centerText",
        afterDatasetsDraw(chart) {
            const {
                ctx,
                chartArea: {top, bottom, left, right},
            } = chart
            const cx = (left + right) / 2
            const cy = (top + bottom) / 2
            ctx.save()
            ctx.textAlign = "center"
            ctx.textBaseline = "middle"
            ctx.fillStyle = "#37495C"
            if (values.title) {
                ctx.font = "800 20px Urbanist, sans-serif"
                ctx.fillText(values.title, cx, cy - (values.subtitle ? 10 : 0))
            }
            if (values.subtitle) {
                ctx.font = "12px Urbanist, sans-serif"
                ctx.fillText(values.subtitle, cx, cy + (values.title ? 10 : 0))
            }
            ctx.restore()
        },
    }
}
